import { Injectable } from '@angular/core';
import { ModalType } from '@app/core/enums/modal.enums';
import { WidgetType } from '@app/core/enums/widget/widget-type.enum';
@Injectable({
  providedIn: 'root',
})
export class DynamicImportService {
  slots: Map<string, ComponentProvider> = new Map<string, ComponentProvider>();
  dynamicModals: Map<string, any> = new Map<string, any>();
  constructor() {}

  init(){
    this.setSlots();
    this.importPopupsDynamically();
  }

  setSlots() {
    this.slots.set(
      WidgetType.BUTTON,
      new ComponentProvider(
        true,
        import('@app/widgets/button/button.component').then(
          (c) => c.ButtonComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.DYNAMIC_INPUT,
      new ComponentProvider(
        true,
        import('@app/widgets/input-type/input-type.component').then(
          (c) => c.InputTypeComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.ICON,
      new ComponentProvider(
        true,
        import('@app/widgets/icons/icons.component').then(
          (c) => c.IconsComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.FIXED_BOTTOM_BAR,
      new ComponentProvider(
        true,
        import('@app/widgets/fixed-bottom-bar/fixed-bottom-bar.component').then(
          (c) => c.FixedBottomBarComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.APP_INSTALL_BANNER,
      new ComponentProvider(
        true,
        import('@app/widgets/app-install-banner/app-install-banner.component').then(
          (c) => c.AppInstallBannerComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.ADD_MORE_ADDRESS,
      new ComponentProvider(
        true,
        import('@app/widgets/banners-widget/banners-widget.component').then(
          (i) => i.BannersWidgetComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.ADS_V2,
      new ComponentProvider(
        true,
        import('@app/widgets/related-video/related-video.component').then(
          (c) => c.RelatedVideoComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.ALL_CATEGORIES,
      new ComponentProvider(
        true,
        import('@app/widgets/all-categories/all-categories.component').then(
          (i) => i.AllCategoriesComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.BANNER,
      new ComponentProvider(
        true,
        import('@app/widgets/banners-widget/banners-widget.component').then(
          (i) => i.BannersWidgetComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.BREADCRUMBS,
      new ComponentProvider(
        true,
        import('@app/widgets/breadcrumbs/breadcrumbs.component').then(
          (c) => c.BreadcrumbsComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.BULK_QUANTITY_DISCOUNT,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/bulk-quantity-discount/bulk-quantity-discount.component'
        ).then((c) => c.BulkQuantityDiscountComponent),
      ),
    );

    this.slots.set(
      WidgetType.CART_PAGE_ADDRESS,
      new ComponentProvider(
        true,
        import('@app/widgets/cart-address/cart-address.component').then(
          (c) => c.CartAddressComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.CART_PAGE_PRODUCT_CARD,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/cart-product-card/cart-product-card.component'
        ).then((c) => c.CartProductCardComponent),
      ),
    );

    this.slots.set(
      WidgetType.CART_STAGE,
      new ComponentProvider(
        true,
        import('@app/widgets/cart-stage/cart-stage.component').then(
          (c) => c.CartStageComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.CATEGORIES,
      new ComponentProvider(
        true,
        import('@app/widgets/categories-list/categories-list.component').then(
          (i) => i.CategoriesListComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.CHECK_DELIVERY_DETAILS,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/check-delivery-details/check-delivery-details.component'
        ).then((c) => c.CheckDeliveryDetailsComponent),
      ),
    );
    this.slots.set(
      WidgetType.COMPOSED_RATING_REVIEW,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/composed-rating-review/composed-rating-review.component'
        ).then((c) => c.ComposedRatingReviewComponent),
      ),
    );
    this.slots.set(
      WidgetType.CREATIVE_CARD,
      new ComponentProvider(
        true,
        import('@app/widgets/creative-card/creative-card.component').then(
          (i) => i.CreativeCardComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.THANK_YOU_PAGE_OPTIONS,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/thank-you-page-options/thank-you-page-options.component'
        ).then((c) => c.ThankYouPageOptionsComponent),
      ),
    );

    this.slots.set(
      WidgetType.EMI_OPTIONS,
      new ComponentProvider(
        true,
        import('@app/widgets/emi-options/emi-options.component').then(
          (c) => c.EmiOptionsComponent,
        ),
      ),
    );
    // TODO No need to map same component with diffrent identifier
    this.slots.set(
      WidgetType.EMPTY_SEARCH,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/no-products-found/no-products-found.component'
        ).then((c) => c.NoProductsFoundComponent),
      ),
    );
    this.slots.set(
      WidgetType.NO_PRODUCTS_FOUND,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/no-products-found/no-products-found.component'
        ).then((c) => c.NoProductsFoundComponent),
      ),
    );
    this.slots.set(
      WidgetType.EXPLORE_OTHER_CATEGORIES,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/explore-other-categories/explore-other-categories.component'
        ).then((c) => c.ExploreOtherCategoriesComponent),
      ),
    );
    this.slots.set(
      WidgetType.FAMILY_ATTRIBUTES,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/family-attributes/family-attributes.component'
        ).then((c) => c.FamilyAttributesComponent),
      ),
    );
    this.slots.set(
      WidgetType.FILTERS_SORT_BY,
      new ComponentProvider(
        true,
        import('@app/widgets/filters-sort-by/filters-sort-by.component').then(
          (c) => c.FiltersSortByComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.GSTIN_VERIFICATION,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/gstin-verification/gstin-verification.component'
        ).then((c) => c.GstinVerificationComponent),
      ),
    );
    this.slots.set(
      WidgetType.GST_WIDGET,
      new ComponentProvider(
        true,
        import('@app/widgets/gst-registration/gst-registration.component').then(
          (c) => c.GstRegistrationComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.HEADER_CONTENT,
      new ComponentProvider(
        true,
        import('@app/widgets/header-content/header-content.component').then(
          (c) => c.HeaderContentComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.IB_COIN_INFO_AND_REVIEW_AND_RATINGS,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/ib-coin-info-and-review-ratings-count/ib-coin-info-and-review-ratings-count.component'
        ).then((c) => c.IbCoinInfoAndReviewRatingsCountComponent),
      ),
    );
    this.slots.set(
      WidgetType.LIST_GRID,
      new ComponentProvider(
        true,
        import('@app/widgets/list-grid-view/list-grid-view.component').then(
          (c) => c.ListGridViewComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.MULTIMEDIA,
      new ComponentProvider(
        true,
        import('@app/widgets/multimedia/multimedia.component').then(
          (i) => i.MultimediaComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.OFFERS_AND_COUPONS,
      new ComponentProvider(
        true,
        import('@app/widgets/offers-coupons/offers-coupons.component').then(
          (c) => c.OffersCouponsComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.OMU,
      new ComponentProvider(
        true,
        import('@app/widgets/banners-widget/banners-widget.component').then(
          (i) => i.BannersWidgetComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.OUT_OF_STOCK_FORM,
      new ComponentProvider(
        true,
        import('@app/widgets/out-of-stock/out-of-stock.component').then(
          (c) => c.OutOfStockComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.PARTNER_OFFERS,
      new ComponentProvider(
        true,
        import('@app/widgets/partner-offers/partner-offers.component').then(
          (c) => c.PartnerOffersComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.PAYMENT_MODES,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/payment-modes/payment-modes/payment-modes.component'
        ).then((c) => c.PaymentModesComponent),
      ),
    );

    this.slots.set(
      WidgetType.PLP_FILTERS,
      new ComponentProvider(
        true,
        import('@app/widgets/filters/filters.component').then(
          (c) => c.FiltersComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.PMU_V2,
      new ComponentProvider(
        true,
        import('@app/widgets/product-carousel/product-carousel.component').then(
          (i) => i.ProductCarouselComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.PRODUCT_FEATURES,
      new ComponentProvider(
        true,
        import('@app/widgets/product-features/product-features.component').then(
          (c) => c.ProductFeaturesComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.PRODUCT_PAGE_SUMMARY,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/product-page-summary/product-page-summary.component'
        ).then((c) => c.ProductPageSummaryComponent),
      ),
    );

    this.slots.set(
      WidgetType.PRODUCT_PRICE_SUMMARY,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/product-price-summary/product-price-summary.component'
        ).then((c) => c.ProductPriceSummaryComponent),
      ),
    );

    this.slots.set(
      WidgetType.PRODUCT_SUMMARY_GRID,
      new ComponentProvider(
        true,
        import('@app/widgets/product-summary/product-summary.component').then(
          (c) => c.ProductSummaryComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.PRODUCT_SUMMARY_LIST,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/product-summary-list/product-summary-list.component'
        ).then((c) => c.ProductSummaryListComponent),
      ),
    );
    this.slots.set(
      WidgetType.QUANTITY_CHANGE,
      new ComponentProvider(
        true,
        import('@app/widgets/quantity-change/quantity-change.component').then(
          (c) => c.QuantityChangeComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.REQUEST_CALLBACK,
      new ComponentProvider(
        true,
        import('@app/widgets/request-callback/request-callback.component').then(
          (c) => c.RequestCallbackComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.REVIEW_AND_RATINGS,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/review-and-ratings/review-and-ratings.component'
        ).then((c) => c.ReviewAndRatingsComponent),
      ),
    );

    this.slots.set(
      WidgetType.SEARCH_PRODUCTS_COUNT,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/search-products-count/search-products-count.component'
        ).then((c) => c.SearchProductsCountComponent),
      ),
    );
    this.slots.set(
      WidgetType.SEO,
      new ComponentProvider(
        true,
        import('@app/widgets/seo/seo.component').then((i) => i.SeoComponent),
      ),
    );

    this.slots.set(
      WidgetType.SORT_BY,
      new ComponentProvider(
        true,
        import('@app/widgets/sort-by/sort-by.component').then(
          (c) => c.SortByComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.TEXT_CARD,
      new ComponentProvider(
        true,
        import('@app/widgets/text-card/text-card.component').then(
          (i) => i.TextCardComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.TEXT_HEADING,
      new ComponentProvider(
        true,
        import('@app/widgets/text-heading/text-heading.component').then(
          (c) => c.TextHeadingComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.VIEW_ALL,
      new ComponentProvider(
        true,
        import('@app/widgets/view-all/view-all.component').then(
          (c) => c.ViewAllComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.ICON_WITH_TEXT_LIST,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/icon-with-text-list/icon-with-text-list.component'
        ).then((c) => c.IconWithTextListComponent),
      ),
    );

    this.slots.set(
      WidgetType.PROFILE_CARD,
      new ComponentProvider(
        true,
        import('@app/widgets/profile-card/profile-card.component').then(
          (c) => c.ProfileCardComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.ORDER_VIEWER,
      new ComponentProvider(
        true,
        import('@app/widgets/order-viewer/order-viewer.component').then(
          (c) => c.OrderViewerComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.ADDRESS,
      new ComponentProvider(
        true,
        import('@app/widgets/address/address.component').then(
          (c) => c.AddressComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.ADDRESS_FORM,
      new ComponentProvider(
        true,
        import('@app/widgets/address-form/address-form.component').then(
          (i) => i.AddressFormComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.PASSWORD_CHANGER,
      new ComponentProvider(
        true,
        import('@app/widgets/password-changer/password-changer.component').then(
          (c) => c.PasswordChangerComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.ATLAS_WIDGET,
      new ComponentProvider(
        true,
        import('@app/widgets/all-brands/all-brands.component').then(
          (c) => c.AllBrandsComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.SEARCH_BAR,
      new ComponentProvider(
        true,
        import('@app/widgets/search-bar/search-bar.component').then(
          (c) => c.SearchBarComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.DROPDOWN,
      new ComponentProvider(
        true,
        import('@app/widgets/dropdown/dropdown.component').then(
          (c) => c.DropDownComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.REUSABLE_PAGINATION_BAR,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/reusable-pagination-bar/reusable-pagination-bar.component'
        ).then((c) => c.ReusablePaginationBarComponent),
      ),
    );

    this.slots.set(
      WidgetType.GST_INFO_CARD,
      new ComponentProvider(
        true,
        import('@app/widgets/gst-info-card/gst-info-card.component').then(
          (c) => c.GstInfoCardComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.TESTIMONIAL,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/client-testimonials/client-testimonials.component'
        ).then((i) => i.ClientTestimonialsComponent),
      ),
    );

    this.slots.set(
      WidgetType.TEXT,
      new ComponentProvider(
        true,
        import('@app/widgets/text/text.component').then((c) => c.TextComponent),
      ),
    );

    this.slots.set(
      WidgetType.TABLE_CONTENT,
      new ComponentProvider(
        true,
        import('@app/widgets/table-content/table-content.component').then(
          (c) => c.TableContentComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.TAB,
      new ComponentProvider(
        true,
        import('@app/widgets/tab/tab/tab.component').then(
          (c) => c.TabComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.BANK_ACCOUNT_VIEWER,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/bank-account-viewer/bank-account-viewer.component'
        ).then((c) => c.BankAccountViewerComponent),
      ),
    );
    this.slots.set(
      WidgetType.BANK_ACCOUNT_FORM,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/bank-account-form/bank-account-form.component'
        ).then((c) => c.BankAccountFormComponent),
      ),
    );

    this.slots.set(
      WidgetType.REVIEW_PROGRESS_BAR,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/review-progress-monitor/review-progress-monitor.component'
        ).then((c) => c.ReviewProgressMonitorComponent),
      ),
    );
    this.slots.set(
      WidgetType.REVIEW_CARD,
      new ComponentProvider(
        true,
        import('@app/widgets/reviewer/reviewer.component').then(
          (c) => c.ReviewerComponent,
        ),
      ),
    );

    // this.slots.set(WidgetType.FAMILY_ITEMS, FamilyItemsComponent);

    this.slots.set(
      WidgetType.RETURNS_TABLE,
      new ComponentProvider(
        true,
        import('@app/widgets/return-viewer/return-viewer.component').then(
          (c) => c.ReturnViewerComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.MEDIA_UPLOAD,
      new ComponentProvider(
        true,
        import('@app/widgets/media-uploader/media-uploader.component').then(
          (c) => c.MediaUploaderComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.ORDER_STATE_PRODUCT_CARD,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/order-state-item-card/order-state-item-card.component'
        ).then((c) => c.OrderStateItemCardComponent),
      ),
    );

    this.slots.set(
      WidgetType.FORM,
      new ComponentProvider(
        true,
        import('@app/widgets/form/form.component').then((c) => c.FormComponent),
      ),
    );

    this.slots.set(
      WidgetType.FIXED_FEATURES_SPECIFICATIONS,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/popups/product-detail-specification/product-detail-specification.component'
        ).then((c) => c.ProductDetailSpecificationComponent),
      ),
    );

    this.slots.set(
      WidgetType.FAMILY_PRODUCT_LISTING,
      new ComponentProvider(
        true,
        import(
          '@app/widgets/family-products-viewer/family-products-viewer.component'
        ).then((c) => c.FamilyProductsViewerComponent),
      ),
    );

    this.slots.set(
      WidgetType.ACCORDION,
      new ComponentProvider(
        true,
        import('@app/widgets/accordion/accordion.component').then(
          (c) => c.AccordionComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.SIDE_BAR,
      new ComponentProvider(
        true,
        import('@app/widgets/sidebar/sidebar.component').then(
          (c) => c.SidebarComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.WHATSAPP_CHAT,
      new ComponentProvider(
        true,
        import('@app/widgets/whatsapp-chat/whatsapp-chat.component').then(
          (c) => c.WhatsappChatComponent,
        ),
      ),
    );

    this.slots.set(
      WidgetType.HIGH_VALUE_PDP,
      new ComponentProvider(
        true,
        import('@app/widgets/high-value-pdp/high-value-pdp.component').then(
          (c) => c.HighValuePdpComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.DIVIDER,
      new ComponentProvider(
        true,
        import('@app/widgets/divider/divider.component').then(
          (c) => c.Divider,
        ),
      ),
    );
    
    this.slots.set(
      WidgetType.CUSTOMER_HELPLINE_OPTIONS,
      new ComponentProvider(
        true,
        import('@app/widgets/helpline-options-pdp/helpline-options-pdp.component').then(
          (c) => c.HelplineOptionsPdpComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.PO_NUMBER,
      new ComponentProvider(
        true,
        import('@app/widgets/enter-po-number/enter-po-number.component').then(
          (c) => c.EnterPoNumberComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.B2C_CONFIRMATION_POPUP,
      new ComponentProvider(
        true,
        import('@app/widgets/b2c-confirmation-widget/b2c-confirmation-widget.component').then(
          (c) => c.B2cConfirmationWidgetComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.USER_QUOTE,
      new ComponentProvider(
        true,
        import('@app/widgets/user-quote/user-quote.component').then(
          (c) => c.UserQuoteComponent,
        ),
      ),
    );
    this.slots.set(
      WidgetType.IB_CREDIT_ORDER_CARD,
      new ComponentProvider(
        true,
        import('@app/widgets/ib-credit-order-card/ib-credit-order-card.component').then(
          (c) => c.IbCreditOrderCardComponent,
        ),
      ),
    )
    this.slots.set(
      WidgetType.IB_CREDIT_PAYMENT_DETAIL_CARD,
      new ComponentProvider(
        true,
        import('@app/widgets/credit-payment-detail-card/credit-payment-detail-card.component').then(
          (c) => c.CreditPaymentDetailCardComponent,
        ),
      ),
    )
    this.slots.set(
      WidgetType.NPS_THANK_YOU_SUBMISSION,
      new ComponentProvider(
        true,
        import('@app/widgets/nps-thankyou-widget/nps-thankyou-widget.component').then(
          (c) => c.NpsThankyouWidgetComponent,
        ),
      ),
    );
  }

  importPopupsDynamically() {
    this.dynamicModals.set(
      ModalType.EMI_OPTIONS,
      import(
        '@app/widgets/popups/emi-options-popup/emi-options-popup.component'
      ).then((i) => i.EmiOptionsPopupComponent),
    );

    this.dynamicModals.set(
      ModalType.PROMOS_AND_COUPONS,
      import(
        '@app/widgets/popups/view-all-coupons/view-all-coupons.component'
      ).then((i) => i.ViewAllCouponsComponent),
    );

    this.dynamicModals.set(
      ModalType.MORE_FILTER_OPTIONS,
      import(
        '@app/widgets/popups/more-filter-options/more-filter-options.component'
      ).then((i) => i.MoreFilterOptionsComponent),
    );

    this.dynamicModals.set(
      ModalType.PAYMENT_CONFIRMATION,
      import(
        '@app/widgets/popups/payment-confirmation-popup/payment-confirmation-popup.component'
      ).then((i) => i.PaymentConfirmationPopupComponent),
    );

    this.dynamicModals.set(
      ModalType.PAYMENT_DIALOG,
      import(
        '@app/widgets/popups/payment-dialog/payment-dialog.component'
      ).then((i) => i.PaymentDialogComponent),
    );
    this.dynamicModals.set(
      ModalType.DESCRIPTION_AND_SPECIFICATIONS,
      import(
        '@app/widgets/popups/product-detail-specification/product-detail-specification.component'
      ).then((i) => i.ProductDetailSpecificationComponent),
    );

    this.dynamicModals.set(
      ModalType.PARTNER_OFFERS,
      import(
        '@app/widgets/popups/partner-offers/partner-offers.component'
      ).then((i) => i.PartnerOffersComponent),
    );

    this.dynamicModals.set(
      ModalType.MULTIMEDIA,
      import('@app/widgets/multimedia/multimedia.component').then(
        (i) => i.MultimediaComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.ALL_CATEGORIES_DIALOG,
      import(
        '@app/widgets/popups/all-categories-popup/all-categories-popup.component'
      ).then((i) => i.AllCategoriesPopupComponent),
    );

    this.dynamicModals.set(
      ModalType.PDP_REQUESTS,
      import(
        '@app/widgets/popups/pdp-requests-popup/pdp-requests-popup.component'
      ).then((i) => i.PdpRequestsPopupComponent),
    );

    this.dynamicModals.set(
      ModalType.WRITE_A_REVIEW_POPUP,
      import(
        '@app/widgets/popups/write-a-review-popup/write-a-review-popup.component'
      ).then((i) => i.WriteAReviewPopup),
    );

    this.dynamicModals.set(
      ModalType.BRAND_CATEGORY_LISTING,
      import(
        '@app/widgets/popups/brand-category-listing/brand-category-listing.component'
      ).then((i) => i.BrandCategoryListingComponent),
    );

    this.dynamicModals.set(
      ModalType.COMMON_CONFIRMATION_POPUP,
      import(
        '@app/widgets/popups/common-confirmation-popup/common-confirmation-popup.component'
      ).then((i) => i.CommonConfirmationPopupComponent),
    );

    this.dynamicModals.set(
      ModalType.ERROR_POPUP,
      import('@app/widgets/popups/error-popup/error-popup.component').then(
        (i) => i.ErrorPopupComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.HIGH_VALUE,
      import('@app/widgets/high-value-pdp/high-value-pdp.component').then(
        (i) => i.HighValuePdpComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.GSTIN_UPDATION_IN_ADDRESS_CONFIRMATION,
      import('@app/widgets/popups/gstin-address-confirmation/gstin-address-confirmation.component').then(
        (i) => i.GstinAddressConfirmationComponent,
      ),
    );

    this.dynamicModals.set(
      ModalType.B2C_CONFIRMATION_POPUP,
      import(
        '@app/widgets/popups/b2c-confirmation-popup/b2c-confirmation-popup.component'
      ).then((i) => i.B2cConfirmationPopupComponent),
    );

    this.dynamicModals.set(
      ModalType.IFRAME_POPUP,
      import(
        '@app/widgets/popups/iframe-popup/iframe-popup.component'
      ).then((i) => i.IframeComponent),
    );

  }
}

export class ComponentProvider {
  lazy = false;
  component: any;

  constructor(lazy: boolean, component: any) {
    this.lazy = lazy;
    this.component = component;
  }
}
